import { useQuery } from '@tanstack/react-query'
import api from '../../lib/api'

export const FALLBACK_DISCORD_INVITE_URL = 'https://discord.gg/YR3bA8Dgff'

export interface DiscordInviteResponse {
  url: string
}

export function useDiscordInvite() {
  return useQuery<DiscordInviteResponse>({
    queryKey: ['discordInvite'],
    queryFn: async () => {
      const response = await api.get<DiscordInviteResponse>('/config/discord-invite')
      return response.data
    },
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  })
}
